import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AdminDashboard from '../components/admin/AdminDashboard'
import AdminLogin from '../components/admin/AdminLogin'
import { createSession, isSessionValid, destroySession, refreshSession, recordLogin } from '../utils/auth'

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (isSessionValid()) {
      setIsAuthenticated(true)
    }
  }, [])

  // Refresh session on user activity
  useEffect(() => {
    if (!isAuthenticated) return
    const handleActivity = () => refreshSession()
    window.addEventListener('mousemove', handleActivity)
    window.addEventListener('keydown', handleActivity)
    window.addEventListener('click', handleActivity)
    return () => {
      window.removeEventListener('mousemove', handleActivity)
      window.removeEventListener('keydown', handleActivity)
      window.removeEventListener('click', handleActivity)
    }
  }, [isAuthenticated])

  // Check session validity every minute
  useEffect(() => {
    if (!isAuthenticated) return
    const interval = setInterval(() => {
      if (!isSessionValid()) {
        setIsAuthenticated(false)
        navigate('/admin')
      }
    }, 60000)
    return () => clearInterval(interval)
  }, [isAuthenticated, navigate])

  const handleLogin = () => {
    recordLogin()
    createSession()
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    destroySession()
    setIsAuthenticated(false)
    navigate('/admin')
  }

  return (
    <div className="admin">
      {isAuthenticated ? (
        <AdminDashboard onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </div>
  )
}

export default Admin
